import React from 'react';
import { Link } from 'react-router-dom';
//components
import { Row } from 'components/Layout/Grid';
import Text from 'components/Text';
//assets
import backBtn from 'img/icon-back.svg';

interface BackButtonProps {
  onClick?: Function;
}

export const BackButton: React.FC<BackButtonProps> = ({ onClick }) => {
  return (
    <Row className="py-1 back-button mb-3 mt-3">
      <Link
        to="/cotacoes-dashboard"
        className="py-1 back-button d-flex"
        onClick={() => onClick && onClick()}
      >
        <img src={backBtn} alt="" className="mr-1" />
        <Text size={12}>Grid de cotações/pedidos</Text>
      </Link>
    </Row>
  );
};